(function () {
  const badgeSelector = '#alma-badge';
  const targetSelector = '.ecom-product-single__price-container .ecom-product-single-afterpay';
  const priceContainerSelector = '.ecom-product-single__price-container';

  function injectAlmaStyle() {
    if (document.getElementById('roi-product-alma-style')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'roi-product-alma-style';
    style.textContent = `
      .ecom-product-single__price-container {
        align-items: flex-start !important;
      }

      .ecom-product-single__price-container-grid {
        width: 100% !important;
      }

      .ecom-product-single__price-container .ecom-product-single__price--prices {
        display: inline-flex !important;
        align-items: baseline !important;
        justify-content: flex-start !important;
        gap: 12px !important;
        flex-wrap: wrap !important;
      }

      .ecom-product-single__price-container .ecom-product-single-afterpay {
        width: 100% !important;
        margin-top: 14px !important;
      }

      .ecom-product-single__price-container #alma-badge {
        width: min(460px, 100%) !important;
        max-width: 100% !important;
        margin: 0 !important;
        clear: both !important;
      }

      .ecom-product-single__price--prices > #alma-badge {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  function moveAlmaBadge() {
    injectAlmaStyle();

    const badge = document.querySelector(badgeSelector);
    const target = document.querySelector(targetSelector);

    if (!(badge instanceof HTMLElement) || !(target instanceof HTMLElement)) {
      return false;
    }

    if (target.contains(badge)) {
      return true;
    }

    target.appendChild(badge);
    return true;
  }

  function watchAlmaBadge() {
    moveAlmaBadge();

    const priceContainer = document.querySelector(priceContainerSelector) || document.body;
    const observer = new MutationObserver(function () {
      moveAlmaBadge();
    });

    observer.observe(priceContainer, {
      childList: true,
      subtree: true
    });

    window.setTimeout(moveAlmaBadge, 500);
    window.setTimeout(moveAlmaBadge, 1500);
    window.setTimeout(moveAlmaBadge, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchAlmaBadge, { once: true });
    return;
  }

  watchAlmaBadge();
})();
